/* ============================================
   INVERSION X — Theme JavaScript
   Mobile-first interactions
   ============================================ */

(function() {
  'use strict';

  /* --- Mobile Drawer --- */
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var menuClose = document.querySelector('[data-menu-close]');
  var drawer = document.querySelector('[data-mobile-drawer]');
  var overlay = document.querySelector('[data-drawer-overlay]');

  function openDrawer() {
    if (drawer) drawer.classList.add('is-active');
    if (overlay) overlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (drawer) drawer.classList.remove('is-active');
    if (overlay) overlay.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  if (menuToggle) menuToggle.addEventListener('click', openDrawer);
  if (menuClose) menuClose.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  /* --- Product Gallery Dots (Mobile swipe indicator) --- */
  var gallery = document.querySelector('[data-product-gallery]');
  var dotsContainer = document.querySelector('[data-gallery-dots]');

  if (gallery && dotsContainer) {
    var dots = dotsContainer.querySelectorAll('.product__gallery-dot');
    var items = gallery.querySelectorAll('.product__gallery-item');

    if (dots.length > 0 && items.length > 0) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            var index = Array.prototype.indexOf.call(items, entry.target);
            dots.forEach(function(d, i) {
              d.classList.toggle('is-active', i === index);
            });
          }
        });
      }, {
        root: gallery,
        threshold: 0.6
      });

      items.forEach(function(item) {
        observer.observe(item);
      });
    }
  }

  /* --- Variant Picker --- */
  document.querySelectorAll('[data-variant-picker]').forEach(function(picker) {
    var form = picker.closest('form');
    var select = form ? form.querySelector('select[name="id"]') : null;
    var priceEl = document.querySelector('[data-product-price]');
    var addBtn = form ? form.querySelector('[type="submit"]') : null;
    var options = picker.querySelectorAll('[data-variant-option]');
    var stickyAtc = document.querySelector('[data-sticky-atc]');
    var stickyPrice = stickyAtc ? stickyAtc.querySelector('[data-sticky-price]') : null;
    var stickyInput = stickyAtc ? stickyAtc.querySelector('input[name="id"]') : null;
    var stickyBtn = stickyAtc ? stickyAtc.querySelector('[type="submit"]') : null;

    options.forEach(function(option) {
      option.addEventListener('click', function() {
        options.forEach(function(o) { o.classList.remove('is-selected'); });
        option.classList.add('is-selected');

        var variantId = option.getAttribute('data-variant-id');
        var variantPrice = option.getAttribute('data-variant-price');
        var variantAvailable = option.getAttribute('data-variant-available');

        if (select) select.value = variantId;
        if (stickyInput) stickyInput.value = variantId;

        if (priceEl && variantPrice) priceEl.textContent = variantPrice;
        if (stickyPrice && variantPrice) stickyPrice.textContent = variantPrice;

        var soldOut = variantAvailable === 'false';

        if (addBtn) {
          addBtn.disabled = soldOut;
          addBtn.textContent = soldOut ? 'sold out' : 'add to cart — ' + (variantPrice || '');
        }
        if (stickyBtn) {
          stickyBtn.disabled = soldOut;
          stickyBtn.textContent = soldOut ? 'sold out' : 'add to cart';
        }
      });
    });
  });

  /* --- Quantity Buttons --- */
  document.querySelectorAll('[data-quantity]').forEach(function(wrapper) {
    var minus = wrapper.querySelector('[data-quantity-minus]');
    var plus = wrapper.querySelector('[data-quantity-plus]');
    var input = wrapper.querySelector('input');

    if (minus) {
      minus.addEventListener('click', function() {
        var val = parseInt(input.value) || 1;
        if (val > 1) input.value = val - 1;
      });
    }

    if (plus) {
      plus.addEventListener('click', function() {
        var val = parseInt(input.value) || 1;
        input.value = val + 1;
      });
    }
  });

  /* --- Marquee Clone for Infinite Scroll --- */
  document.querySelectorAll('.marquee__track').forEach(function(track) {
    var clone = track.innerHTML;
    track.innerHTML = clone + clone;
  });

})();
